/**
 * Production-grade API configuration loader.
 * Handles environment-specific base URLs for Azure and Localhost.
 */

const getRequiredEnvVar = (key: string): string => {
  const value = (import.meta.env?.[key] as string) || (process.env?.[key] as string);
  
  if (!value && import.meta.env?.PROD) {
    console.warn(`Environment variable ${key} is missing in production!`);
  }
  
  return value || '';
};

export const SERVICES_API_BASE_URL = getRequiredEnvVar('REACT_APP_SERVICES_API_URL');
export const DIAGNOSTIC_API_BASE_URL = getRequiredEnvVar('REACT_APP_DIAGNOSTIC_API_URL');
export const JOBBOARD_API_BASE_URL = getRequiredEnvVar('REACT_APP_JOBBOARD_API_URL');
export const RECAPTCHA_SITE_KEY = getRequiredEnvVar('REACT_APP_RECAPTCHA_SITE_KEY');
export const MICROSOFT_CLIENT_ID = getRequiredEnvVar('REACT_APP_MICROSOFT_CLIENT_ID');
export const GOOGLE_CLIENT_ID = getRequiredEnvVar('REACT_APP_GOOGLE_CLIENT_ID');